module.exports = __webpack_public_path__ + "img/pic_chahua.1e18acac.png";